import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/careers/page.tsx");
